import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Bulb({ color = colors.secondary['DEFAULT'], ...props }: Props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.91699 7.5C4.91699 4.69256 7.19288 2.41667 10.0003 2.41667C12.8078 2.41667 15.0837 4.69256 15.0837 7.5C15.0837 8.85543 14.5542 10.0856 13.6892 10.9975C13.0286 11.694 12.3205 12.5726 11.9712 13.6121C11.9537 13.6224 11.9344 13.6337 11.9134 13.6457C11.7938 13.714 11.6213 13.8061 11.4145 13.898C10.9877 14.0877 10.4742 14.25 10.0005 14.25C9.5267 14.25 9.01312 14.0877 8.58627 13.898C8.37941 13.806 8.20682 13.714 8.08727 13.6457C8.06623 13.6337 8.04693 13.6224 8.02946 13.6121C7.68018 12.5726 6.97202 11.694 6.31142 10.9975C5.44649 10.0856 4.91699 8.85543 4.91699 7.5ZM8.25033 15.3831V15.8333C8.25033 16.7998 9.03383 17.5833 10.0003 17.5833C10.9668 17.5833 11.7503 16.7998 11.7503 15.8333V15.3832C11.2664 15.5734 10.6472 15.75 10.0005 15.75C9.35366 15.75 8.73437 15.5734 8.25033 15.3831ZM10.0003 0.916672C6.36445 0.916672 3.41699 3.86413 3.41699 7.5C3.41699 9.25461 4.1044 10.8503 5.22309 12.0297C6.11061 12.9655 6.75033 13.9211 6.75033 14.9258V15.8333C6.75033 17.6283 8.2054 19.0833 10.0003 19.0833C11.7953 19.0833 13.2503 17.6283 13.2503 15.8333V14.9258C13.2503 13.9211 13.89 12.9655 14.7776 12.0297C15.8963 10.8503 16.5837 9.25461 16.5837 7.5C16.5837 3.86413 13.6362 0.916672 10.0003 0.916672Z"
        fill={color}
      />
    </svg>
  );
}
